import { Component, EventEmitter, Input, Output, HostBinding } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

/** One section of a review page: done tick, title, edit button, details. */
@Component({
  selector: 'app-review-wrapper',
  standalone: true,
  imports: [MatTooltipModule],
  templateUrl: './review-wrapper.component.html',
  styleUrl: './review-wrapper.component.css',
})
export class ReviewWrapperComponent {
  /** The `title` input would otherwise also land on the host as a native tooltip. */
  @HostBinding('attr.title') readonly hostTitle = null;

  @Output() onEdit = new EventEmitter();
  @Input({ required: true }) title = '';
  /** A filled tick when the section is done; an empty ring while it still needs input. */
  @Input() complete = true;
}
